import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useLineCardHeaderStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    lineHeaderWrapper: {
        display: 'flex',
        flexDirection: 'row'
    },
    amountDueWrapper: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr .1fr',
        justifyContent: 'end',
        columnGap: tokens.spacingHorizontalM,
        width: '100%',
        '@media screen and (max-width: 780px)': {
            columnGap: '0',
            gridTemplateColumns: '1fr 1fr'
        }
    },
    lineLabel: {
        display: 'flex',
        width: '100%',
        columnGap: tokens.spacingHorizontalS,
        alignItems: 'center'
    },
    lineHeader: {
        fontSize: tokens.fontSizeHero700
    },
    orderButton: {
        fontSize: tokens.fontSizeBase600,
        cursor: 'pointer'
    },
    orderButtons: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        columnGap: tokens.spacingHorizontalS
    },
    itemInfoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: '100px'
    },
    promoWrapper: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: tokens.spacingHorizontalS,
        marginRight: tokens.spacingHorizontalS,
        '@media screen and (max-width: 780px)': {
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between'
        }
    },
    itemInfoLabel: {
        fontSize: tokens.fontSizeBase300,
        display: 'flex',
        justifyContent: 'end'
    },
    itemInfo: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
        ...shorthands.margin('0'),
        display: 'flex',
        justifyContent: 'end',
        fontWeight: tokens.fontWeightBold
    },
    promoInfoLabel: {
        color: 'green'
    },
    desktopPromoDisplay: {
        '@media screen and (max-width: 780px)': {
            display: 'none'
        }
    },
    mobilePromoDisplay: {
        '@media screen and (min-width: 780px)': {
            display: 'none'
        }
    },
    largeScreenDelete: {
        display: 'flex',
        justifyContent: 'end',
        '@media screen and (max-width: 780px)': {
            display: 'none'
        }
    }
});
